import params from '../../../setup/config/params'
import GoogleCalendarEmbed from ".."
import OAuthCallbackHandler from '../components/OAuthCallbackHandler'

const routes = {
    googleCalendar: {
        path: '/calendar',
        component: GoogleCalendarEmbed,
        exact: true,
        auth: true,
        role: params.user.roles.admin.key,
        module: "engagement",
        subModule: "calendar",
        action: "canView",
    },
    authVerification: {
        path: '/auth/google/callback',
        component: OAuthCallbackHandler,
        exact: true,
        auth: true,
        role: params.user.roles.admin.key,
        module: "engagement",
        subModule: "calendar",
        action: "canView",
    },
    outlookAuthVerification: {
        path: '/auth/outlook/callback',
        component: OAuthCallbackHandler,
        exact: true,
        auth: true,
        role: params.user.roles.admin.key,
        module: "engagement",
        subModule: "calendar",
        action: "canView",
    }
}

export default routes